import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

type AdminAnswerWarningModalProps = {
  isOpen: boolean;
  close: () => void;
  onConfirm: () => void;
  onGoBack: () => void;
  isLoading?: boolean;
};

export const AdminAnswerWarningModal = ({
  isOpen,
  close,
  onConfirm,
  onGoBack,
  isLoading = false,
}: AdminAnswerWarningModalProps) => (
  <Modal.Root open={isOpen} onOpenChange={close}>
    <Modal.Content size="small">
      <StatusModal type="warning" title="Update customer's response?">
        This will update the response the customer provided, and the updated
        response will be visible to them.
        <br />
        <br />
        Are you sure you want to continue?
      </StatusModal>
      <Modal.FooterButtonGroup>
        <Button type="button" disabled={isLoading} onClick={onGoBack}>
          Go back
        </Button>
        <Button
          type="button"
          customType="primary"
          isLoading={isLoading}
          disabled={isLoading}
          onClick={onConfirm}
        >
          Confirm
        </Button>
      </Modal.FooterButtonGroup>
    </Modal.Content>
  </Modal.Root>
);
